<template>
  <div>
    <v-container v-if="trip">
      <v-row>
        <v-col cols="12" class="flex">
          <h3>Historie für {{ trip.category }} {{ trip.trainNumber }} <v-btn icon size="x-small" variant="text" v-bind:color="favoriteColor" @click="toggleFavorite"><v-icon>mdi-star</v-icon></v-btn></h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-if="trip" v-model="openPanel">
            <Trip :route="item" :trip="trip" :show-train-number="false" :panel-value="String(item.id)" v-for="item in history" v-bind:key="item.id" />
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else-if="err">
      <v-row>
        <v-col cols="12" class="flex">
          <h3>Zug {{ trainNumber }} nicht gefunden (#{{ err.response.status }})</h3>
        </v-col>
      </v-row>
    </v-container>
    <LoadingIndicator v-else/>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import OpenPanelMixin from '@/mixins/OpenPanelMixin'
import SearchRangeMixin from '@/mixins/SearchRangeMixin'
import TitleMixin from '@/mixins/TitleMixin'
import Trip from '@/components/Trip.vue'

export default {
  name: 'TrainHistory',
  mixins: [OpenPanelMixin, SearchRangeMixin, TitleMixin],
  props: ['trainNumber'],

  components: {
    LoadingIndicator,
    Trip,
  },

  computed: {
    title: function() {
      if (this.trip) {
        return `${this.trip.category} ${this.trip.trainNumber} - ${import.meta.env.VITE_NAME}`;
      }

      return import.meta.env.VITE_NAME;
    },

    panelStorageKey: function() {
      return this.trainNumber ? `bahnomat.openDay.train.${this.trainNumber}` : null;
    },

    ...mapState({
      favoriteColor: function(state) {
        var favoriteTrains = state.favoriteTrains
        var result = favoriteTrains.includes(this.trainNumber.toString()) ? "yellow" : "grey"
        this.$log.debug(`Determining favoriteColor. favoriteTrains = [${favoriteTrains}], trainNumber = ${this.trainNumber}. color = ${result}`)
        return result
      },

      searchRange: state => state.search.range,
    }),
  },

  data: () => ({
    err: null,
    trip: null,
    history: null,
  }),

  methods: {
    getTrainHistory: function() {
      this.trip = null;
      this.history = null;
      this.err = null;

      if (this.trainNumber) {
        this.$log.info(`Retrieving train history for ${this.trainNumber}`);

        this.$api
          .get(`/train/${this.trainNumber}/history${this.searchRangeToQuery(this.searchRange)}`)
          .then(response => {
            var data

            if (Array.isArray(response.data)) {
              data = response.data[0]
            } else {
              data = response.data
            }

            this.trip = data.trip;
            this.history = data.history;

            // Upgrade this train's "Zuletzt angesehen" chip from "Zug 70" to
            // "ICE 70". The router recorded the visit with the route parameter
            // alone; the category only arrives with this response.
            if (this.trip && this.trip.category) {
              this.annotateVisit({
                type: 'train',
                id: String(this.trainNumber),
                category: this.trip.category,
              });
            }

            this.restoreOpenPanel((this.history || []).map(item => String(item.id)), this.$route.query.trip);
          })
          .catch(err => {
            this.$log.error(`Caught error: ${err}`)
            this.err = err;
          });
      }
    },

    toggleFavorite: function() {
      this.toggleFavoriteTrain({train: this.trainNumber})
    },

    ...mapMutations([
      'toggleFavoriteTrain',
      'annotateVisit',
    ])
  },

  mounted: function () {
    this.getTrainHistory()
  },

  watch: {
    searchRange: function () {
      this.getTrainHistory()
    },

    trainNumber: function () {
      this.getTrainHistory()
    },
  },
};
</script>
